/**
 * TadReamk Eye Product Configuration
 *
 * NEW STRUCTURE: Text content moved to JSON translations
 * This file now contains only non-translatable assets and configuration
 */

import tadreamkEyeImage from "../../assets/images/products/TadReamk eye.webp";
import { FEATURE_ICONS, STATUS_ICONS } from "../../configs/emojis";
import { APP_CONFIG } from "../../configs/config";

// New config structure - assets and non-translatable data only
export const tadreamkEyeConfig = {
  id: "tadreamk-eye",
  numericId: 1, // Legacy numeric ID
  image: tadreamkEyeImage,
  ctaUrl: APP_CONFIG.TADREAMK_EYE_URL,
  icons: {
    TARGET: FEATURE_ICONS.TARGET,
    AI: FEATURE_ICONS.AI,
    LIGHTNING: FEATURE_ICONS.LIGHTNING,
    BAR_CHART: FEATURE_ICONS.BAR_CHART,
    CHECK: STATUS_ICONS.CHECK,
  },
};

// Legacy export for backward compatibility
// Will be used by old components that haven't been migrated yet
const tadreamkEyeData = {
  id: 1,
  image: tadreamkEyeImage,
  title: "TadReamk Eye",
  abstract:
    "Advanced trademark search and monitoring system. Discover similar trademarks, monitor infringements, and protect your intellectual property with our comprehensive search engine.",
  ctaUrl: APP_CONFIG.TADREAMK_EYE_URL,
  ctaText: "Start Searching",
  category: "Search & Monitoring",
  primaryFeatureTag: "Trademark Infringement Detection",
  imageAlt: "TadReamk Eye trademark similarity and monitoring",
  ctaPlacement: "top",
  showOverviewHeading: false,
  description: [
    {
      icon: FEATURE_ICONS.TARGET,
      title: "Global, targeted search",
      text: "Search across international registers with one query and get results that respect the nuances of each jurisdiction. We normalize classes, statuses, and owner fields; resolve transliterations and alternative scripts; and harmonize Nice classifications so filters behave consistently. Smart ranking pushes high‑risk candidates to the top while suppressing obvious non‑matches, reducing paging and saving analysts hours per project and per country.",
    },
    {
      icon: FEATURE_ICONS.AI,
      title: "Multimodal similarity",
      text: "Our models compare phonetic, visual, and conceptual signals simultaneously using learned embeddings. Word marks are evaluated with phonetic distance, morphological variants, and language‑aware stemming, while logos are analyzed by shape, structure, and negative space. A lightweight concept graph captures category proximity (e.g., tech vs. apparel) to explain why two marks might be confused in commerce. The result: true look‑alikes and sound‑alikes that basic text search simply misses.",
    },
    {
      icon: FEATURE_ICONS.LIGHTNING,
      title: "Always‑on monitoring",
      text: "Create watchlists once and let our engine do the rest. We stream newly filed applications and office actions, de‑duplicate against your portfolio, and apply adaptive thresholds to minimize false positives. Digest emails summarize what matters; real‑time web alerts support urgent action windows. Teams stay ahead of conflicts instead of reacting after publication.",
    },
    {
      icon: FEATURE_ICONS.BAR_CHART,
      title: "Actionable insights",
      text: "Side‑by‑side comparisons, similarity heatmaps, and plain‑language rationales turn complex analytics into decisions. Export investigation packs—screenshots, evidence links, dates, and classes—ready to share with internal stakeholders or outside counsel. Risk scoring with confidence bands helps triage large result sets quickly without losing transparency.",
    },
    {
      icon: STATUS_ICONS.CHECK,
      title: "Built for IP workflows",
      text: "Designed for professionals who live in search. Organize matters by project, annotate candidates with structured notes, assign tasks, and capture every action in an audit trail from first query to final decision. Bulk actions, CSV/PDF export, and API endpoints connect TadReamk Eye to your docketing tools and data warehouse so the process stays fast and accountable.",
    },
  ],
  testimonial: {
    text: "TadReamk Eye has transformed our IP protection strategy. The AI-powered search capabilities are incredibly accurate and have helped us avoid costly conflicts.",
    author: "Sarah Johnson",
    title: "IP Manager, TechCorp",
    avatar:
      "https://images.unsplash.com/photo-1494790108755-2616b612b169?w=150&h=150&fit=crop&crop=face",
  },
};

export default tadreamkEyeData;
